import { useState, useEffect } from 'react';
import { LinkTargetProperties } from "global/components/linkSettings/interfaces"
import { PremiumPaywallSignModes, PaywallPlans, SiteLinks } from '../../../../global/paywall/paywallInterfaces';
import { PremiumPaywallMobileSignUp } from "./premiumPaywallMobileSignup"
import { PremiumPaywallMobileSignin } from "./premiumPaywallMobileSignin"
import { useRedirect } from '../../../../global/paywall/useRedirect';


export interface PremiumPaywallState {
  mode: PremiumPaywallSignModes;
  isNewspaper?: boolean;
}
export interface LegalLink {
  url: string;
  target: LinkTargetProperties;
}
interface PremiumPaywallMobileProps {
  setIsRedirecting?: (isRedirect: boolean) => void;
  legalLinks?: {terms: LegalLink; privacy: LegalLink};
  mode?: PremiumPaywallSignModes;
}
export const PremiumPaywallMobile = (props:PremiumPaywallMobileProps) => {
  const [authMode , setAuthMode] = useState<PremiumPaywallState>({
    mode: 'signUp',
    isNewspaper: false,  
  });
  const [email, setEmail] = useState<string>('');
  const [agreesTerms, setAgreeTerms] = useState(false);
  const [password, setPassword] = useState('');
  const [isRedirecting, setIsRedirecting] = useState(false);

  useRedirect({  enabled: isRedirecting });
  const { mode } = props;

  

  useEffect(() => {
    if (mode !== undefined) {
      setAuthMode({ mode, isNewspaper: false });
    }
  }, [mode]);


  const getFormByMode = () => {
    if (authMode.mode === 'signUp') {
      return (
        <PremiumPaywallMobileSignUp
          email={email}
          password={password}
          agreesTerms={agreesTerms}
          setEmail={setEmail}
          setPassword={setPassword}
          setAgreesTerms={setAgreeTerms}
          setMode={setAuthMode}
          setIsRedirecting={setIsRedirecting}
        />
      );
    }
    return (
      <PremiumPaywallMobileSignin
        email={email}
        password={password}
        agreesTerms={agreesTerms}
        setEmail={setEmail}
        setPassword={setPassword}
        setAgreesTerms={setAgreeTerms}
        setMode={setAuthMode}
        setIsRedirecting={setIsRedirecting}
        isNewspaper={authMode.isNewspaper}
      />);
  };

  return <div className="premium-paywall-mobile">{getFormByMode()}</div>;
};
